import React from 'react'
import { Typography, Spin, Divider } from 'antd'
import { useSelector } from 'react-redux'
import CommonTable from '../../components/CommonTable'

const { Title } = Typography

const DependenciesView = () => {
  const { upstreamApps, downstreamApps, isLoading } = useSelector((state) => state.dependencies)

  const columns = [
    {
      title: 'Application Name',
      dataIndex: 'sourceDB',
      key: 'sourceDB',
      width: '15%',
    },
    {
      title: 'Application Server',
      dataIndex: 'targetDB',
      key: 'targetDB',
      width: '15%',
      render: (text) => {
        // Split by dot and return the first part (server name)
        if (text && text.includes('.')) {
          return text.split('.')[0]
        }
        return text
      },
    },
    {
      title: 'Application Database',
      dataIndex: 'targetDB',
      key: 'applicationDatabase',
      width: '15%',
      render: (text) => {
        // Split by dot and return the second part (database name)
        if (text && text.includes('.')) {
          return text.split('.')[1]
        }
        return text
      },
    },
    {
      title: 'Tables',
      dataIndex: 'tables',
      key: 'tables',
      width: '15%',
    },
    {
      title: 'Dependency Type',
      dataIndex: 'dependencyType',
      key: 'dependencyType',
      width: '15%',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: (text) => (
        <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
          {text}
        </div>
      ),
    },
  ]

  if (isLoading) {
    return <Spin size="large" />
  }

  if (upstreamApps.length === 0 && downstreamApps.length === 0) {
    return <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>No data available</div>
  }

  return (
    <div>
      <Title level={5}>Upstream Applications</Title>
      <CommonTable
        columns={columns}
        dataSource={upstreamApps}
        rowKey="dependencyId"
        pagination={false}
      />
      
      <Divider />
      
      <Title level={5}>Downstream Applications</Title>
      <CommonTable
        columns={columns}
        dataSource={downstreamApps}
        rowKey="dependencyId"
        pagination={false}
      />
    </div>
  )
}

export default DependenciesView
